module.exports = __webpack_public_path__ + "img/renshou.600e0b04.png";